import React from 'react';
import { Link } from 'react-router-dom';
import './BlogSection.css';

const BlogSection = () => {
  const blogPosts = [
    {
      id: 1,
      title: "Understanding Gold Purity: 24K, 22K, and 18K Explained",
      excerpt: "Learn about the differences between 24K, 22K, and 18K gold, and how purity affects value and durability.",
      date: "March 15, 2024",
      readTime: "5 min read",
      category: "Gold Basics"
    },
    {
      id: 2,
      title: "How to Calculate Gold Price: A Comprehensive Guide",
      excerpt: "Master the art of calculating gold prices with our step-by-step guide to understanding gold valuation.",
      date: "March 10, 2024",
      readTime: "7 min read",
      category: "Gold Trading"
    },
    {
      id: 3,
      title: "Factors Affecting Gold Prices in 2024",
      excerpt: "Explore the key economic and geopolitical factors influencing gold prices in the current market.",
      date: "March 5, 2024",
      readTime: "6 min read",
      category: "Market Analysis"
    },
    {
      id: 4,
      title: "Gold Investment: Tips for Beginners",
      excerpt: "Essential tips and strategies for beginners looking to invest in gold and build a diversified portfolio.",
      date: "March 1, 2024",
      readTime: "8 min read",
      category: "Investment"
    }
  ];

  return (
    <section className="blog-section">
      <div className="blog-container">
        <h2 className="blog-title">Latest Gold Market Insights</h2>
        <p className="blog-description">
          Stay informed with our expert analysis and educational content about gold markets, investment strategies, and market trends.
        </p>
        
        <div className="blog-grid">
          {blogPosts.map(post => (
            <Link to={`/blog/${post.id}`} key={post.id} className="blog-card-link">
              <article className="blog-card">
                <div className="blog-card-header">
                  <span className="blog-category">{post.category}</span>
                  <span className="blog-date">{post.date}</span>
                </div>
                <h3 className="blog-card-title">{post.title}</h3>
                <p className="blog-card-excerpt">{post.excerpt}</p>
                <div className="blog-card-footer">
                  <span className="blog-read-time">{post.readTime}</span>
                  <button className="read-more-btn">Read More</button>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection; 